import { createAction } from 'Lib/reduxUtils';

import { Photo } from 'Store/profile/user.types';

import {
  ASSIGN_PLACEHOLDERS,
  MEDIA_HYDRATION_NUDGE_RECEIVED,
  PLACEHOLDER_CONSUMED,
  PLACEHOLDERS_RECEIVED,
} from './constants';
import { MediaInfoType, Placeholder } from './types';

export const placeholdersReceived = createAction(
  PLACEHOLDERS_RECEIVED,
  (placeholders: Placeholder[]) => placeholders
);
export const placeholderConsumed = createAction(PLACEHOLDER_CONSUMED, (placeholderId: string) => ({
  placeholderId,
}));
export const assignPlaceholders = createAction(
  ASSIGN_PLACEHOLDERS,
  (blobs: MediaInfoType[], placeholderIds: string[]) => ({
    blobs,
    placeholderIds,
  })
);
export const mediaHydrationNudgeReceived = createAction(
  MEDIA_HYDRATION_NUDGE_RECEIVED,
  ({
    mediaId,
    processedPhotos,
    originalMediaUrl,
  }: {
    mediaId: string;
    processedPhotos: Photo[];
    originalMediaUrl: string;
  }) => ({
    mediaId,
    processedPhotos,
    originalMediaUrl,
  })
);
